/* eslint-disable jsx-a11y/anchor-is-valid */
import { IonContent, IonPage } from '@ionic/react';
import classNames from 'classnames';
import React from 'react';
import { Header } from './Header';
import styles from './HelpPopup.module.css';
import { IconButton } from './IconButton';
import { PostContentsToHTML } from './PostContentsToHTML';
import { IconClose } from './QuirkIcons';

export const HelpPopup: React.FC<{ onDismiss: () => {}; contents: string; title: string }> = ({
	onDismiss,
	contents,
	title
}) => {
	return (
		<>
			<IonPage>
				<>
					<Header title={title} left={<IconButton icon={<IconClose />} onClick={() => onDismiss()} />} />
					<IonContent>
						<div className={classNames(styles.container)}>
							<PostContentsToHTML>{contents}</PostContentsToHTML>
						</div>
					</IonContent>
				</>
			</IonPage>
		</>
	);
};
